import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col text-left" }
const _hoisted_2 = { class: "content-row" }
const _hoisted_3 = { class: "flex-1 font-bold text-base lg:text-lg" }
const _hoisted_4 = { class: "flex-1 font-bold text-base lg:text-lg" }
const _hoisted_5 = { class: "content-row" }
const _hoisted_6 = { class: "flex-1 text-xs text-gray-500" }
const _hoisted_7 = { class: "flex-1 text-xs text-gray-500" }
const _hoisted_8 = { class: "content-row" }
const _hoisted_9 = { class: "content-row" }
const _hoisted_10 = { class: "flex-1 flex gap-2 items-center pt-4 pb-1" }
const _hoisted_11 = { class: "font-bold text-base lg:text-lg" }
const _hoisted_12 = { class: "flex-1 flex gap-2 items-center pt-4 pb-1" }
const _hoisted_13 = { class: "font-bold text-base lg:text-lg" }
const _hoisted_14 = { class: "content-row" }
const _hoisted_15 = { class: "flex-1 text-xs text-gray-500" }
const _hoisted_16 = { class: "flex-1 text-xs text-gray-500" }

import CardComponent from "@/views/Calculators/DestinyMatrix/components/CardComponent.vue";
import CircleComponent from "@/views/Calculators/DestinyMatrix/components/CircleComponent.vue";
import SummarizeComponent from "@/views/Calculators/DestinyMatrix/components/SummarizeComponent.vue";
import { useI18n } from "vue-i18n";

import { DestinyMatrix } from "@/types/destinyMatrix";


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonalCardComponent',
  props: {
    matrix: {}
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardComponent, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)(
                "calculators.destiny-matrix.personal-card.yourself-search-title"
              )), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("calculators.destiny-matrix.personal-card.socialisation-title")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("calculators.destiny-matrix.personal-card.yourself-search-desc")), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("calculators.destiny-matrix.personal-card.socialisation-desc")), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(SummarizeComponent, {
            class: "flex-1",
            firstLabel: _unref(t)('calculators.destiny-matrix.personal-card.heaven'),
            secondLabel: _unref(t)('calculators.destiny-matrix.personal-card.earth'),
            firstValue: __props.matrix?.personal.h ?? 0,
            secondValue: __props.matrix?.personal.e ?? 0,
            sumValue: __props.matrix?.personal.personal ?? 0
          }, null, 8, ["firstLabel", "secondLabel", "firstValue", "secondValue", "sumValue"]),
          _createVNode(SummarizeComponent, {
            class: "flex-1",
            firstLabel: _unref(t)('calculators.destiny-matrix.personal-card.male'),
            secondLabel: _unref(t)('calculators.destiny-matrix.personal-card.female'),
            firstValue: __props.matrix?.personal.m ?? 0,
            secondValue: __props.matrix?.personal.f ?? 0,
            sumValue: __props.matrix?.personal.social ?? 0
          }, null, 8, ["firstLabel", "secondLabel", "firstValue", "secondValue", "sumValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)(
                  "calculators.destiny-matrix.personal-card.spirit-harmony-title"
                )), 1),
            _createVNode(CircleComponent, {
              value: __props.matrix?.personal.harmony ?? 0
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)("calculators.destiny-matrix.personal-card.planetary-title")), 1),
            _createVNode(CircleComponent, {
              value: __props.matrix?.personal.planetary ?? 0
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)("calculators.destiny-matrix.personal-card.spirit-harmony-desc")), 1),
          _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)("calculators.destiny-matrix.personal-card.planetary-desc")), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})